// redux/notificationsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  getNotificationApi,
  markNotificationAsReadApi,
  markSingleNotificationAsReadApi
} from "../../services/pushNotificationService";

// Async thunk to fetch notifications
export const fetchNotifications = createAsyncThunk(
  "notifications/fetch",
  async (userId, { rejectWithValue }) => {
    try {
      const result = await getNotificationApi(userId);
      return result.data;
    } catch (error) {
      // Use rejectWithValue to pass the error to the slice
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
// mark notification as a read
export const markNotificationAsRead = createAsyncThunk(
  "markNotificationAsRead/fetch",
  async ({ userId, patientId }, { rejectWithValue }) => {
    try {
      const result = await markNotificationAsReadApi(userId, patientId);
      return result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const markSingleNotificationAsRead = createAsyncThunk(
  "markSingleNotificationAsRead/fetch",
  async (id, { rejectWithValue }) => {
    try {
      const result = await markSingleNotificationAsReadApi(id);
      return result;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Notifications slice
const notificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    notificationData: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    // Add a new notification to the state
    addNotification: (state, action) => {
      state.notificationData.unshift(action.payload); // Add to the beginning of the array
    },
    // Mark all notifications as read
    markAllAsRead: (state) => {
      state.notificationData = state.notificationData.map((notif) => ({
        ...notif,
        isRead: true,
      }));
    },
  },
  extraReducers: (builder) => {
    builder
      // Pending state: when the request starts
      .addCase(fetchNotifications.pending, (state) => {
        state.isLoading = true;
        state.error = null; // Clear previous errors
      })
      // Fulfilled state: when the request succeeds
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notificationData = action.payload; // Populate data with the fetched notifications
      })
      // Rejected state: when the request fails
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload; // Set the error message
      })
      // Handle mark as read
      .addCase(markSingleNotificationAsRead.fulfilled, (state, action) => {
        const { _id } = action.payload.data;
        const index = state.notificationData.findIndex(
          (notif) => notif._id === _id
        );
        if (index !== -1) {
          // Remove the notification with the matching ID
          state.notificationData = state.notificationData.filter(
            (notif) => notif._id !== _id
          );
        }
      })
      .addCase(markSingleNotificationAsRead.rejected, (state, action) => {
        state.error = action.payload; // Handle any errors
      });
  },
});

// Export actions and reducer
export const { addNotification, markAllAsRead } = notificationsSlice.actions;
export default notificationsSlice.reducer;
